import {
	deleteImagesFromProperty,
	getImagesByPropertyId,
	setImageOrderForProperty,
	uploadImagesToProperty
} from '../../../../../entities/images/actions';
import { withRefreshActionsForFirstArg } from '../../../actions/actions';

export const getPhotos = getImagesByPropertyId;
export const uploadPhotos = withRefreshActionsForFirstArg(uploadImagesToProperty);
export const deletePhotos = withRefreshActionsForFirstArg(deleteImagesFromProperty);
export const reorderPhotos = setImageOrderForProperty;
